var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 96,
    viewBox: "0 0 93 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.4715 26.8099C91.8175 65.3655 76.0281 89.7662 47.6444 95.7563L46.4766 96L45.3181 95.7469C15.6358 89.4006 -0.265774 62.8439 0.52837 20.9605L0.565741 18.5701L2.31286 16.9483C13.9914 6.07441 29.6314 0.0562445 46.3551 0H46.5887C56.8098 0 66.6105 2.23103 75.3554 6.46812C75.944 6.75872 76.0561 7.55551 75.5796 8.00547L68.479 14.5954C67.9558 15.0829 67.2084 15.2141 66.5451 14.961C48.4947 8.07109 26.7164 10.9583 11.7211 23.6321C11.6651 48.239 17.9154 77.6362 46.5046 84.498C60.9207 81.0765 77.1119 69.8932 80.5967 37.8338C80.9051 35.0403 81.1106 32.0875 81.2134 28.9659L92.4155 18.5794L92.4622 20.9605C92.5089 22.9478 92.5089 24.8976 92.4809 26.8193L92.4715 26.8099Z",
    fill: "url(#paint0_linear_78_14252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4062 18.57L81.2041 28.9565L43.5803 63.8468C42.8422 64.5311 41.7024 64.503 40.9924 63.8L23.353 46.1017C22.6243 45.3705 22.6243 44.18 23.353 43.4488L29.9491 36.8213C30.6778 36.0902 31.8644 36.0902 32.5931 36.8213L42.618 46.8704L73.5055 18.2232L81.0079 11.2676C81.6432 10.677 82.5961 10.5927 83.3155 11.0801C85.9035 12.8424 88.3607 14.811 90.6777 16.967L92.4062 18.5794V18.57Z",
    fill: "url(#paint1_linear_78_14252)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M92.4715 26.8101L80.5874 37.8247C80.8957 35.0312 81.1013 32.0784 81.204 28.9568L92.4061 18.5703L92.4528 20.9513C92.4996 22.9386 92.4996 24.8884 92.4715 26.8101Z",
    fill: "#013546"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_14252",
    x1: 14.1222,
    y1: 73.3241,
    x2: 94.5045,
    y2: -6.78119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01698B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#01B38B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_78_14252",
    x1: 22.8111,
    y1: 37.5431,
    x2: 92.4062,
    y2: 37.5431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01698B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#01B38B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonogram);
export default __webpack_public_path__ + "static/media/Monogram.fa9d4d05d2c3a01791a33a63f82606e0.svg";
export { ForwardRef as ReactComponent };